import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyUsers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    render() {

        const formId = this.props.formid !== undefined ? this.props.formid : "";

        return (
            <LegacyFrame withHeader={false} pageTitle={"Users"} formname={"table_6"} formId={formId} customClass={"field-customization-container org-container"} customFrameClass={"users-container"}/>
        );
    }
}

export default LegacyUsers;
